import _defineProperty from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from "react";
import CreditCardTermModal from "@/components/CreditCardTermModal";
import CvvModal from "@/components/CvvModal";
import { ExpirationDateField, SingleCheckboxField, TextField } from "@/components/Form/Parts/index";
import { useModal } from "@/hooks";
import formStyles from "@/styles/Form.module.scss";
import paymentSelectStyles from "@/styles/PaymentSelect.module.scss";
import classnames from "classnames";
import { useCallback, useRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var IconHelp = function IconHelp(props) {
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: /*#__PURE__*/_jsxs("g", {
      transform: "translate(-412.636 -587.133)",
      children: [/*#__PURE__*/_jsx("circle", {
        cx: "7",
        cy: "7",
        r: "7",
        transform: "translate(412.636 587.133)",
        fill: "#646464"
      }), /*#__PURE__*/_jsx("g", {
        style: {
          isolation: "isolate"
        },
        children: /*#__PURE__*/_jsx("path", {
          d: "M418.865,596.055a3.488,3.488,0,0,0,.031-.421l-.011-.189a1.959,1.959,0,0,1,.41-1.289,3.017,3.017,0,0,1,.939-.75c.64-.43.88-.749.88-1.2,0-.61-.53-.99-1.389-.99a1.336,1.336,0,0,0-1.429,1.32l-1.48-.18a2.481,2.481,0,0,1,.789-1.5,3.239,3.239,0,0,1,2.209-.7c1.61,0,2.719.819,2.719,2a1.9,1.9,0,0,1-.349,1.179,4.312,4.312,0,0,1-1.23,1.019c-.63.42-.779.66-.779,1.189a5.03,5.03,0,0,0,.029.511Zm1.39.83v1.369h-1.449v-1.369Z",
          fill: "#e6e6e6"
        })
      })]
    })
  }));
};
IconHelp.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "14",
  height: "14",
  viewBox: "0 0 14 14"
};
export default function CreditCardInput(_ref) {
  var _errors$cardNumber, _errors$expirationDat, _errors$cvv, _errors$firstName, _errors$lastName, _errors$mailAddress, _errors$creditCardTer;
  let {
    register,
    errors,
    setValue,
    visible
  } = _ref;
  if (!visible) return null;
  const {
    showModal
  } = useModal();
  const bsDelKey = useRef();
  const handleKeyDown = useCallback(e => {
    bsDelKey.current = e.code === "Backspace" || e.code === "Delete";
  });
  const handleInputCardNumber = useCallback(e => {
    if (bsDelKey.current) return false;
    const digit = e.target.value.replace(/[^\d]+/g, "");

    // ブランド判別
    const chunkMap = (() => {
      if (/^(34|37)/.test(digit)) {
        // Amex 4-6-5
        return [[0, 4], [4, 10], [10, 15]];
      } else if (/^(30|36|38|39)/.test(digit)) {
        // Diners 4-6-4
        return [[0, 4], [4, 10], [10, 14]];
      } else {
        // Other 4-4-4-4
        return [[0, 4], [4, 8], [8, 12], [12, 16]];
      }
    })();
    const value = chunkMap.reduce((acc, n, i) => {
      const [start, end] = n;
      const chnkValue = digit.slice(start, end);
      acc = acc + chnkValue;
      if (i !== chunkMap.length - 1 && chnkValue.length === end - start) {
        acc = acc + "-";
      }
      return acc;
    }, "");
    e.target.value = value;
  }, []);
  const handleInputCvv = useCallback(e => {
    if (!/^\d{1,16}$/.test(e.target.value)) {
      e.target.value = e.target.value.replace(/[^\d]+/g, "");
    }
  }, []);
  const handleCvvBtnClick = useCallback(() => {
    showModal( /*#__PURE__*/_jsx(CvvModal, {}), {
      closeButton: false,
      outerAreaClose: false,
      style: "dialogue"
    });
  }, []);
  const handleCreditCardTermBtnClick = useCallback(() => {
    showModal( /*#__PURE__*/_jsx(CreditCardTermModal, {}), {
      closeButton: false,
      outerAreaClose: false,
      style: "creditCardTermModal"
    });
  }, []);
  return /*#__PURE__*/_jsxs("div", {
    className: paymentSelectStyles.addCreditCardSection,
    children: [/*#__PURE__*/_jsx("header", {
      className: paymentSelectStyles.header,
      children: /*#__PURE__*/_jsx("h4", {
        className: paymentSelectStyles.heading,
        children: "\u30AF\u30EC\u30B8\u30C3\u30C8\u30AB\u30FC\u30C9\u60C5\u5831"
      })
    }), /*#__PURE__*/_jsxs("div", {
      className: paymentSelectStyles.creditCardInfoContainer,
      children: [/*#__PURE__*/_jsx("div", {
        className: paymentSelectStyles.creditCardNumberField,
        children: /*#__PURE__*/_jsx(TextField, {
          ref: register,
          name: "cardNumber",
          title: "\u30AF\u30EC\u30B8\u30C3\u30C8\u30AB\u30FC\u30C9\u756A\u53F7",
          placeholder: "\u534A\u89D2\u6570\u5B57\u3067\u30AB\u30FC\u30C9\u756A\u53F7\u3092\u5165\u529B",
          error: (_errors$cardNumber = errors.cardNumber) === null || _errors$cardNumber === void 0 ? void 0 : _errors$cardNumber.message,
          required: true,
          className: paymentSelectStyles.creditCardTextInput,
          onInput: handleInputCardNumber,
          onKeyDown: handleKeyDown
        })
      }), /*#__PURE__*/_jsx("div", {
        className: paymentSelectStyles.creditCardExpirationDateField,
        children: /*#__PURE__*/_jsx("div", {
          children: /*#__PURE__*/_jsx(ExpirationDateField, {
            ref: register,
            name: "expirationDate",
            title: "\u6709\u52B9\u671F\u9650",
            error: (_errors$expirationDat = errors.expirationDate) === null || _errors$expirationDat === void 0 ? void 0 : _errors$expirationDat.message,
            setValue: setValue,
            required: true
          })
        })
      }), /*#__PURE__*/_jsxs("div", {
        className: paymentSelectStyles.creditCardCvvField,
        children: [/*#__PURE__*/_jsxs("legend", {
          className: classnames(formStyles.formTitle, {
            [formStyles.required]: true
          }),
          children: ["\u30BB\u30AD\u30E5\u30EA\u30C6\u30A3\u30B3\u30FC\u30C9", /*#__PURE__*/_jsx("a", {
            onClick: handleCvvBtnClick,
            className: paymentSelectStyles.iconHelp,
            children: /*#__PURE__*/_jsx(IconHelp, {})
          })]
        }), /*#__PURE__*/_jsx(TextField, {
          ref: register,
          inputMode: "numeric",
          name: "cvv",
          placeholder: "\u534A\u89D2\u6570\u5B57\u3067\u5165\u529B",
          error: (_errors$cvv = errors.cvv) === null || _errors$cvv === void 0 ? void 0 : _errors$cvv.message,
          onInput: handleInputCvv,
          maxLength: "4",
          required: true
        })]
      })]
    }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsxs("div", {
      className: paymentSelectStyles.creditCardInfoContainer,
      children: [/*#__PURE__*/_jsxs("div", {
        className: paymentSelectStyles.creditCard3dsField,
        children: [/*#__PURE__*/_jsx("legend", {
          className: classnames(formStyles.formTitle, {
            [formStyles.required]: true
          }),
          children: "\u30AB\u30FC\u30C9\u540D\u7FA9\uFF08\u82F1\u5B57\u540D\uFF09"
        }), /*#__PURE__*/_jsx(TextField, {
          ref: register,
          name: "firstName",
          placeholder: "\u30AB\u30FC\u30C9\u540D\u7FA9\uFF08\u82F1\u5B57\u540D\uFF09",
          error: (_errors$firstName = errors.firstName) === null || _errors$firstName === void 0 ? void 0 : _errors$firstName.message,
          required: true
        })]
      }), /*#__PURE__*/_jsxs("div", {
        className: paymentSelectStyles.creditCard3dsField,
        children: [/*#__PURE__*/_jsx("legend", {
          className: classnames(formStyles.formTitle, {
            [formStyles.required]: true
          }),
          children: "\u30AB\u30FC\u30C9\u540D\u7FA9\uFF08\u82F1\u5B57\u59D3\uFF09"
        }), /*#__PURE__*/_jsx(TextField, {
          ref: register,
          name: "lastName",
          placeholder: "\u30AB\u30FC\u30C9\u540D\u7FA9\uFF08\u82F1\u5B57\u59D3\uFF09",
          error: (_errors$lastName = errors.lastName) === null || _errors$lastName === void 0 ? void 0 : _errors$lastName.message,
          required: true
        })]
      }), /*#__PURE__*/_jsxs("div", {
        className: paymentSelectStyles.creditCard3dsEmailField,
        children: [/*#__PURE__*/_jsx("legend", {
          className: classnames(formStyles.formTitle, {
            [formStyles.required]: true
          }),
          children: "\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9"
        }), /*#__PURE__*/_jsx(TextField, {
          ref: register,
          name: "mailAddress",
          placeholder: "\u534A\u89D2\u82F1\u6570\u5B57\u3067\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9\u3092\u5165\u529B",
          error: (_errors$mailAddress = errors.mailAddress) === null || _errors$mailAddress === void 0 ? void 0 : _errors$mailAddress.message,
          required: true
        })]
      })]
    }), /*#__PURE__*/_jsxs("div", {
      className: paymentSelectStyles.creditCardTermField,
      children: [/*#__PURE__*/_jsxs("div", {
        className: paymentSelectStyles.creditCardTermText,
        children: [/*#__PURE__*/_jsx("a", {
          onClick: handleCreditCardTermBtnClick,
          className: paymentSelectStyles.creditCardTermBtn,
          children: "\u300C\u5229\u7528\u4E0A\u306E\u6CE8\u610F\u304A\u3088\u3073\u500B\u4EBA\u60C5\u5831\u306E\u7B2C\u4E09\u8005\u63D0\u4F9B\u306B\u3064\u3044\u3066\u300D"
        }), "\u3092\u304A\u8AAD\u307F\u3044\u305F\u3060\u304D\u3001\u540C\u610F\u306E\u3046\u3048\u304A\u624B\u7D9A\u304D\u3057\u3066\u304F\u3060\u3055\u3044\u3002"]
      }), /*#__PURE__*/_jsx("div", {
        className: paymentSelectStyles.creditCardTermInput,
        children: /*#__PURE__*/_jsx(SingleCheckboxField, {
          ref: register,
          title: "",
          name: "creditCardTerm",
          defaultChecked: false,
          label: "上記の内容について確認・同意しました",
          error: errors === null || errors === void 0 || (_errors$creditCardTer = errors.creditCardTerm) === null || _errors$creditCardTer === void 0 ? void 0 : _errors$creditCardTer.message
        })
      })]
    })]
  });
}